export const ANALYTICS_CAT_ID = 'C0002';
